import React from 'react'
import L2InformationModules from './L2InformationModules'

const L2InformationSearch = () => {
  return (
    <div>
        <L2InformationModules />
    </div>
  )
}

export default L2InformationSearch